import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

export default function ExtraSection() {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [extras, setExtras] = useState([]);
    const [pagination, setPagination] = useState({});

    useEffect(() => {
        const fetchExtras = async () => {
            const response = await window.apiClient.get(`/data/extra/5/${currentPage}`);
            setExtras(response.data.data);
            setPagination(response.data.pagination);
        };
        fetchExtras();
    }, [currentPage])

    const handleExtraClick = (slug) => { 
        navigate(`/extra/${slug}`);
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            {/* Header Section */}
            <div className="mb-8 text-center">
                <h2 className="text-3xl font-extrabold tracking-wide text-gray-800 uppercase">
                    Ekstrakulikuler
                </h2>
                <h3 className="text-lg text-gray-500">Daftar Ekstrakulikuler Smandapura</h3>
            </div>

            {/* extra List */}
            <div id="listingextra" className="space-y-8">
                {extras.map((extra) => (
                    <div
                    key={extra.encrypted_id}
                    className="flex overflow-hidden flex-col bg-white rounded-lg border border-gray-200 shadow-md md:flex-row"
                >
                    {/* Content */}
                    <div className="h-48 md:w-1/3 md:h-auto">
                        <img
                            src={`https://admin.sman2amlapura.sch.id/images/Activity/${extra.url_logo}`}
                            alt={extra.nama_activity}
                            className="object-cover w-full h-full"
                        />
                    </div>
                    <div className="flex flex-col justify-between p-6 md:w-full">
                        <div>
                            <h4 className="mb-4 text-xl font-bold text-gray-800">
                                {extra.nama_activity}
                            </h4>
                            <p className="text-base leading-relaxed text-gray-600">
                                {extra.short_desc_activity}
                            </p>
                        </div>

                        {/* Button */}
                        <div className="mt-6">
                            <button
                                className="px-6 py-2 font-medium text-white bg-blue-500 rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                onClick={() => handleExtraClick(extra.encrypted_id)}
                            >
                                Lihat Detail
                            </button>
                        </div>
                    </div>
                </div>
            ))}
            </div>

            {/* Pagination */}
            <div className="mt-8">
            <ul className="flex justify-center space-x-2 text-sm font-medium">
                    {Array.from({ length: pagination.total_pages }, (_, index) => (
                        <li
                            key={index + 1}
                            className={`px-4 py-2 rounded-md cursor-pointer hover:bg-blue-600 ${currentPage === index + 1
                                ? "text-white bg-blue-500"
                                : "text-gray-700 bg-gray-300 hover:bg-gray-400"
                                }`}
                            onClick={() => paginate(index + 1)}
                        >
                            {index + 1}
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
}
